/* Adds one decorative guide before native personalization fields. */
(() => {
  'use strict';
  const template = document.getElementById('np-otter-guide-template');
  const section = document.querySelector('[id^="MainProduct-"]');
  if (!template || !section || section.dataset.npOtterGuideBound) return;
  section.dataset.npOtterGuideBound = 'true';
  let frame = 0;
  const decorate = () => {
    frame = 0;
    const fields = section.querySelector('#teeFormInputs');
    if (!fields || !fields.children.length || fields.querySelector('[data-np-otter-guide]')) return;
    fields.prepend(template.content.cloneNode(true));
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(decorate);
  };
  const observer = new MutationObserver(schedule);
  observer.observe(section, { childList: true, subtree: true });
  document.addEventListener('teeinblue-component-injected', schedule);
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    document.removeEventListener('teeinblue-component-injected', schedule);
    cancelAnimationFrame(frame);
  }, { once: true });
  decorate();
})();
